<template>
  <div class="rec-video-container">
    <div class="time-control">
      <el-date-picker
        v-model="startTime"
        type="datetime"
        placeholder="选择开始时间"
        format="yyyy年MM月dd日 HH时mm分ss秒"
        value-format="yyyyMMddHHmmss"
        @change="handleTimeChange"
        style="width: 300px"
      ></el-date-picker>
      <span class="time-separator">至</span>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        placeholder="选择结束时间"
        format="yyyy年MM月dd日 HH时mm分ss秒"
        value-format="yyyyMMddHHmmss"
        @change="handleTimeChange"
        style="width: 300px"
      ></el-date-picker>
      <el-button type="primary" @click="changePlayTime" class="change-btn">切换时间</el-button>
    </div>
    <div id="playWind" ref="playWind"></div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";

export default {
  name: "RecVideo",
  data: function () {
    return {
      videoPlayer: null,
      accessToken: "at.5lu45iqn5cti4r7b1aiaub2g6ot8ckbr-491rkki5i8-1ykot4g-kw31btdsn",
      deviceInfo: {
        deviceSerial: "BG9380217",
        channelNo: 1
      },
      startTime: "20260104173000",
      endTime: "20260104174000"
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initVideoPlayer();
    });
  },
  beforeDestroy() {
    this.destroyVideoPlayer();
  },
  methods: {
    initVideoPlayer() {
      const width = document.documentElement.clientWidth;
      const height = document.documentElement.clientHeight;
      
      this.videoPlayer = new EZUIKit.EZUIKitPlayer({
        id: 'playWind',
        width: width,
        height: height,
        template: "pcRec",
        url: "ezopen://open.ys7.com/BG9380217/1.rec",
        accessToken: this.accessToken
      });
      
      this.$nextTick(() => {
        this.changePlayTime();
      });
    },
    destroyVideoPlayer() {
      if (this.videoPlayer) {
        this.videoPlayer.destroy();
        this.videoPlayer = null;
      }
    },
    changePlayTime() {
      if (this.videoPlayer && this.videoPlayer.changePlayUrl) {
        const playbackUrl = `ezopen://open.ys7.com/${this.deviceInfo.deviceSerial}/${this.deviceInfo.channelNo}.rec?begin=${this.startTime}&end=${this.endTime}`;
        this.videoPlayer.changePlayUrl({url: playbackUrl});
        console.log("切换播放时间:", playbackUrl);
      }
    },
    handleTimeChange() {
      console.log("时间已更改:", this.startTime, this.endTime);
    }
  }
};
</script>

<style>
.rec-video-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.time-control {
  padding: 15px;
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.time-separator {
  color: #606266;
  font-size: 14px;
}

.change-btn {
  margin-left: 15px;
}

#playWind {
  flex: 1;
  width: 100%;
}
</style>
